import CloseIcon from "@heroicons/react/solid/XIcon";

function Modal({
  children,
  open,
  onClose,
}: {
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
}) {
  if (!open) {
    return null;
  }

  return (
    <div className="z-10 absolute flex flex-row items-center inset-0 bg-white/70 backdrop-blur-sm">
      <dialog
        open
        style={{ maxHeight: "80vh" }}
        className="relative flex flex-col p-8 w-full bg-white text-black space-y-4 text-left max-w-xl drop-shadow-lg"
      >
        {children}
        <CloseIcon
          className="text-white h-6 w-6 absolute !mt-0 top-2 right-2 text-background"
          onClick={onClose}
        />
      </dialog>
    </div>
  );
}

export default Modal;
